import { About } from '../types';
import { escapeHtml, sanitizeUrl } from '../utils/security';
import { sectionHeader } from './common';

export function buildAbout(about: About) {
    const root = document.querySelector('[data-section="about"]');
    if (!root) return;

    const profileImgHtml = about.profileImage
        ? `<div class="relative w-full aspect-square rounded-lg overflow-hidden border border-n100">
                <img src="${sanitizeUrl(about.profileImage)}"
                     alt="Profile"
                     class="w-full h-full object-cover"
                />
           </div>`
        : '';

    const tagsHtml = (about.tags || []).map(t => `
        <span class="px-3 py-[5px] rounded-full text-xs font-semibold tracking-[0.5px] bg-n100 text-graphite inline-block">${escapeHtml(t)}</span>
    `).join('');

    root.innerHTML = `
        ${sectionHeader(about.kicker, about.heading)}

        <div class="grid ${about.profileImage ? 'md:grid-cols-[320px_1fr]' : 'grid-cols-1'} gap-12 items-start bg-white border border-n100 rounded-lg p-8 shadow-sm animate-fadeUp">
            ${profileImgHtml}
            <div class="w-full">
                ${tagsHtml ? `<div class="flex flex-wrap gap-2 mb-[22px]">${tagsHtml}</div>` : ''}
                ${about.paragraphs.map(p => `<p class="text-[17px] leading-[1.7] text-n500 mb-[18px] max-w-[62ch] last:mb-0">${escapeHtml(p)}</p>`).join('')}
            </div>
        </div>
    `;
}
